var SectionEntity = {
    section: null,
    shield: null,
    isHovered: false,
    setHover: function (_a) {
        var hover = _a.hover, _b = _a.section, section = _b === void 0 ? null : _b, shield = _a.shield;
        this.section = section;
        this.shield = shield;
        this.isHovered = hover;
    },
};
export default SectionEntity;
